import { Flex, Slider } from "@mantine/core";
import { ceil } from "lodash";
import { DataTableColumn } from "mantine-datatable";
import { useMemo } from "react";

import { TableData, TableRow } from "../../../../components/Table/types.ts";
import { LimitTypeName } from "../../../../graphql/generated.ts";
import { CreditLimitFunnel } from "../../../../types/riskFunnelDashboard.ts";
import { toCurrencyPrice, toPercent } from "../../../../utils/number.ts";
import { LimitTypeNameOptions } from "./constants.ts";

interface Props {
  data: CreditLimitFunnel[] | null | undefined;
}

export const useCreditLimitFunnelTableData = ({ data }: Props): TableData => {
  const columns: DataTableColumn<TableRow>[] = [
    {
      accessor: "limitTypeName",
      title: "",
    },
    {
      accessor: "customerConversion",
      title: "%",
    },
    {
      accessor: "customerCount",
      title: "Number of Customer",
    },
    {
      accessor: "limitRequestCount",
      title: "Number of Limit",
    },
    {
      accessor: "funnelBar",
      title: "Funnel Bar",
      width: 400,
    },
    {
      accessor: "totalNominal",
      title: "Nominal",
    },
    {
      accessor: "sla",
      title: "SLA (Days)",
    },
  ];

  const rows = useMemo(() => {
    const totalRow = data?.find(
      (item) => item.limitTypeName === LimitTypeName.LimitRequested
    );
    return data?.map((item) => {
      const funnel =
        (item.limitRequestCount / (totalRow?.limitRequestCount ?? 0)) * 100;
      return {
        limitTypeName: LimitTypeNameOptions[item.limitTypeName],
        customerConversion: toPercent(item.customerConversion),
        customerCount: item.customerCount,
        limitRequestCount: item.limitRequestCount,
        funnelBar: (
          <Flex w="100%" align="center" justify="space-between" gap={4}>
            <Slider w="100%" maw="320px" value={funnel} disabled />
          </Flex>
        ),
        totalNominal: toCurrencyPrice(item.totalNominal),
        sla: item.sla ? ceil(item.sla, 0) : null,
      };
    });
  }, [data]);

  return [columns, rows];
};
